// export const APIENDPOINT = 'http://pandata.online/api'
// export const APIENDPOINT = 'http://206.189.35.122/api'
// export const APIENDPOINT = `http://${window.location.hostname}/api`
// export const APIENDPOINT = 'http://localhost:3000/api'
export const APIENDPOINT = 'https://api.waterithailand.com/api'
// export const APIENDPOINT = returnEndPointAPI()
export const getHeader = function () {
  const headers = {
    'Content-Type': 'application/json'
  }
  return headers
}

export const getHeaderUser = function () {
  const tokenData = localStorage.getItem('token')
  const headers = {
    'Content-Type': 'application/json',
    'Authorization': 'bearer ' + tokenData
  }
  return headers
}

// function returnEndPointAPI () {
//   const hostname = window.location.hostname
//   let endpoint = ''
//   if (hostname === '206.189.35.122') {
//     endpoint = `http://${window.location.hostname}:8000/api`
//   } else {
//     endpoint = `http://${window.location.hostname}/api`
//   }
//   return endpoint
// }



